import './big-check-list.css'
import './static/check.svg'
